export class GliderCmd {
  public KEY: string
  public FILE_ACCESS: boolean
  public COMMAND_ACCESS: boolean
  public READABLE: boolean
  public RANGE: string
  public EXCLUDED: string
  public DEFAULT: string
  public COMMENTS: string
  public UNIT: string
  /** Type de glider ciblé (code modèle GLI_FABRICANT, ex. 'SXP'/'DXP') — vide = tous les gliders */
  public GLIDER_TYPE: string

  constructor({
    KEY = '',
    FILE_ACCESS = false,
    COMMAND_ACCESS = false,
    READABLE = false,
    RANGE = '',
    EXCLUDED = '',
    DEFAULT = '',
    COMMENTS = '',
    UNIT = '',
    GLIDER_TYPE = '',
  } = {}) {
    this.KEY = KEY
    this.FILE_ACCESS = FILE_ACCESS
    this.COMMAND_ACCESS = COMMAND_ACCESS
    this.READABLE = READABLE
    this.RANGE = RANGE
    this.EXCLUDED = EXCLUDED
    this.DEFAULT = DEFAULT
    this.COMMENTS = COMMENTS
    this.UNIT = UNIT
    this.GLIDER_TYPE = GLIDER_TYPE
  }

  /**
   * Filtre les commandes pour un type de glider donné (GLI_FABRICANT, ex. 'SXP'/'DXP') :
   * garde les lignes génériques (GLIDER_TYPE vide) + les lignes typées correspondantes,
   * puis dédoublonne par KEY avec priorité à la ligne typée.
   * Sans type fourni → liste inchangée (comportement historique).
   */
  static filterByGliderType(cmds: Array<GliderCmd>, gliderType?: string | null) {
    if (!gliderType || gliderType.length == 0) return cmds
    const byKey = new Map<string, GliderCmd>()
    for (const cmd of cmds) {
      const type = cmd.GLIDER_TYPE || ''
      if (type != '' && type != gliderType) continue
      const existing = byKey.get(cmd.KEY)
      // la ligne typée surcharge la générique ; sinon premier arrivé conservé
      if (!existing || (type == gliderType && (existing.GLIDER_TYPE || '') == '')) byKey.set(cmd.KEY, cmd)
    }
    return Array.from(byKey.values())
  }

  static createGliderCmdArray(datas: String) {
    if (!datas || datas.length == 0) return [] as Array<GliderCmd>
    const datasArr = datas.split('\n')
    const firstRow = datasArr.splice(0, 1)[0]
    // trim défensif : retire un éventuel '\r' (CRLF) sur le dernier header
    const headers = firstRow.split(';').map(h => h.trim())
    return datasArr.map(line => GliderCmd.createGliderCmd(line, headers))
  }

  static createGliderCmd(data: string, headers: Array<string>) {
    const datas = data.split(';')
    const cmd: any = {}
    headers.forEach((header, idx) => {
      cmd[header] = GliderCmd.parseCmd(header, datas[idx])
    })
    return new GliderCmd(cmd)
  }

  static parseCmd(name: string, value: string) {
    switch (name) {
      case 'FILE_ACCESS':
      case 'COMMAND_ACCESS':
      case 'READABLE': {
        return value != '0'
      }
      // dernière colonne du CSV : trim défensif (retire un éventuel '\r' de fin de ligne)
      case 'GLIDER_TYPE':
        return (value ?? '').trim()
      default:
        return value
    }
  }
}
